import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SEO, seoConfig } from "@/hooks/useSEO";
import { generateWebPageSchema, generateBreadcrumbSchema } from "@/lib/jsonld";

const Blog = () => {
  const jsonLdSchemas = [
    generateWebPageSchema("Blog", seoConfig.blog.description, "/blog"),
    generateBreadcrumbSchema([
      { name: "Accueil", path: "/" },
      { name: "Blog", path: "/blog" }
    ])
  ];

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <SEO {...seoConfig.blog} jsonLd={jsonLdSchemas} />
      <Header />

      <main className="flex-1">
        {/* Hero Section */}
        <section className="pt-24 lg:pt-40 pb-12 sm:pb-16">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            {/* Badge */}
            <div className="inline-block px-4 py-2 rounded-full border border-[#074155] bg-white text-sm font-semibold text-[#074155] mb-6">
              Ressources
            </div>

            {/* Title H1 */}
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#074155] mb-4">
              Blog <span className="text-[#0c97a9]">Unotif</span>
            </h1>

            {/* Subtitle */}
            <p className="text-[14px] sm:text-base font-medium leading-relaxed text-[#495456] max-w-2xl mx-auto">
              Consultez nos conseils, stratégies et informations concernant le marketing Wallet et les notifications push
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Blog;
